import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { isAppLocale, type AppLocale } from '@/lib/i18n'

export function useAppLocale(): AppLocale {
  const { i18n } = useTranslation()
  return isAppLocale(i18n.language) ? i18n.language : 'it'
}

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(timer)
  }, [value, delayMs])
  return debounced
}
